import React from 'react';
import { FilterFieldBase, type FilterFieldBaseProps } from './FilterFieldBase';

type BasePropsFromWrapped = Omit<FilterFieldBaseProps, 'children'>;

export function withFilterFieldBase<P extends object>(
  Component: React.ComponentType<P>,
  getBaseProps: (props: P) => BasePropsFromWrapped
) {
  const WrappedComponent = React.memo((props: P) => {
    const baseProps = getBaseProps(props);

    return (
      <FilterFieldBase {...baseProps}>
        <Component {...props} />
      </FilterFieldBase>
    );
  });

  const displayName = Component.displayName || Component.name || 'AnonymousFilterField';
  WrappedComponent.displayName = `withFilterFieldBase(${displayName})`;

  return WrappedComponent;
}
